import { Capacitor, registerPlugin } from "@capacitor/core";

// The iOS app's edge swipe back (ios/App/App/BackSwipePlugin.swift). The customer
// menu turns it on while a category's items, a search or the market report is
// showing, and off everywhere else, so the swipe only ever goes from there back to
// the category list (the history entry it goes back over: lib/menuBackEntry.ts).
//
// iOS only: Android's system back gesture already presses back, and Safari in a
// browser has its own swipe. Feature-detected, because the web bundle deploys on
// every merge while the plugin only exists in builds that include it; an older
// build keeps the arrow.

interface BackSwipePlugin {
  setEnabled(options: { enabled: boolean }): Promise<void>;
}
const BackSwipe = registerPlugin<BackSwipePlugin>("BackSwipe");

const hasNativeBackSwipe = (): boolean =>
  Capacitor.getPlatform() === "ios" && Capacitor.isPluginAvailable("BackSwipe");

export function setNativeBackSwipe(enabled: boolean): void {
  if (!hasNativeBackSwipe()) return;
  BackSwipe.setEnabled({ enabled }).catch(() => {});
}
